import './Footer.css';

const Footer: React.FC = () => {
    return (
        <footer id="footer-container" className="footer-container">
            <div>
                <span>
                    Copyright © {new Date().getUTCFullYear()} Majid Ghajari. All rights reserved
                </span>
                <br />
                <a href="https://www.majidg.com" target="_blank" rel="noopener noreferrer">
                    www.majidg.com
                </a>
                <br />
                <a href="mailto:majidgdotcom@gmail.com">
                    majidgdotcom@gmail.com
                </a>
            </div>
        </footer>
    );
};

export default Footer;